<template>
  <pt-sample-recollect-detail class="pt-sample-recollect-detail__withData" :loading="loading" :sampleId="sampleId"
  :orderDetail="orderDetail" :recollectPrice="recollectPrice" :sampleType="sampleType"></pt-sample-recollect-detail>
</template>

<script>
import PtSampleRecollectDetail from './index'
export default {
  name: 'pt-sample-recollect-detail__withData',
  components: {
    'pt-sample-recollect-detail': PtSampleRecollectDetail
  },
  props: {
    sampleId: {
      type: String,
      default: ''
    },
    sampleType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      orderDetail: {},
      recollectPrice: 0,
      detailLoading: false,
      priceLoading: false
    }
  },
  computed: {
    loading () {
      return this.detailLoading || this.priceLoading
    }
  },
  methods: {
    goodsOrderDetail () {
      this.detailLoading = true
      this.$store.dispatch('sampleOrderDetail', this.sampleId).then(res => {
        this.detailLoading = false
        this.orderDetail = res || {}
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取订单详情失败')
      })
    },
    sampleRecollectPrice () {
      this.priceLoading = true
      let api = this.sampleType === 'ADULT_STORAGE' ? 'sampleRecollectPriceAdultlab' : 'sampleRecollectPrice'
      this.$store.dispatch(api, this.sampleId).then(res => {
        this.priceLoading = false
        this.recollectPrice = res.orderActionData && res.orderActionData.order && res.orderActionData.order.sampleRecollectCost
      }).catch(err => {
        this.priceLoading = false
        this.$message.error(err || '获取重采价格失败')
      })
    }
  },
  created () {
    this.goodsOrderDetail()
    this.sampleRecollectPrice()
  }
}
</script>
